import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";
const ProductTypeList = (props: any) => {
  const { handleIsRateType, handleIsActive } = props;
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "VCTS Name",
      accessorKey: "vcts_name",
      cell: NACell,
    },
    {
      header: "Unit",
      accessorKey: "unit",
      cell: NACell,
    },
    {
      header: "Rate By Weight",
      accessorKey: "is_rate_by_weight",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsRateType}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsRateType}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.PRODUCT_TYPE}
      queryKey={"product-types"}
      columns={defaultColumns}
      params={{ level: 1 }}
      addNewPagePath={"/create"}
      tableName={"product-type"}
      onRowClick={handleRowClick}
    />
  );
};

export default ProductTypeList;
